module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz84aGhlFhFf8AABI9FjcwEjUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABgALAAAAAAgACAAAAWxICaOZGmeaKqubOu+cCzPdG0GgX3i9eX/wKAwWJJgBsjk4GKBDH/KAeEiMh6jF+SFkVAgGRRL1qecUkVYcjRdiE7XSMrFAFf6JoRydh3xNepJP3lJb2sLPg6AWj6DSIVRhxcHiksVF41Se1F9FwiUF3KYj0qcnoqCenV9FZ9QhGdXSWITrWqOGGdrFItqQEuamSJUcD8UEQ8/E5xRAhcAI0/R0i48Ojs51tna29zd3jMhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadW_S6.gif
// module id = DWhm
// module chunks = 50